import Header from "./components/Header";
import Hero from "./components/Hero";
import RankSection from "./components/RankSection";
import DataBoard from "./components/DataBoard";
import FocusSection from "./components/FocusSection";
import BuzzSection from "./components/BuzzSection";
import DeepSection from "./components/DeepSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ReportSection from "./components/ReportSection";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans text-foreground-900">
      <Header />
      <main>
        <Hero />
        <RankSection />
        <DataBoard />
        <FocusSection />
        <BuzzSection />
        <DeepSection />
        <FaqSection />
        <AboutSection />
        <ReportSection />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}